import { useEffect } from "react";
import { FieldProps } from "@rjsf/utils";
import { get } from "lodash";
import { MultiselectBubble } from "../../Inputs/MultiselectBubble";
import { Input } from "../__styles__/Inputs";

export const TagsInput = (props: FieldProps) => {
  const items = get(props.schema, "items.enum") as Array<string>;
  const isRequired = props.required && !props.disabled;
  const rawValue = props.formData;

  useEffect(() => {
    if (isRequired && Array.isArray(rawValue) && rawValue.length === 0) {
      props.onChange(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = Array.isArray(rawValue) ? rawValue : (rawValue ?? []);

  return (
    <Input id={props.idSchema.$id}>
      <MultiselectBubble
        items={items}
        selectedItems={value}
        onChange={props.onChange}
        name={props.name}
        required={isRequired}
        label={props.schema.title}
        error={props.rawErrors?.join(", ")}
        description={props.uiSchema?.["ui:description"]}
        disabled={false}
        readonly={props.readonly || props.disabled}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
      />
    </Input>
  );
};
